import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedProduct } from 'actions/tools/OrdersSearchActions';
import {
  ProductCheckbox,
  ProductCheckboxColumn,
  ProductResultsColumn,
  ProductRow,
} from './ProductSearchResultsList.styles';

const ProductSearchResultsList = ({ productSearchResultList }) => {
  const dispatch = useDispatch();
  const [currentProduct, setCurrentProduct] = useState('');

  // This can also mean selected product variant within context of shopify
  const isCurrentlySelectedProduct = (product) => `${product.id}-${product.sku}` === currentProduct;

  // This can also mean selected product variant within context of shopify
  const handleSelectedProduct = (product) => {
    /**
     * SPD-6059: If two products have the same SKU,
     * they will both be selected in the UI.
     *
     * Product ID (sometimes variantId) is added to
     * make a more unique product selection
     */
    setCurrentProduct(`${product.id}-${product.sku}`);
    dispatch(setSelectedProduct(product));
  };

  return productSearchResultList.map((product) =>
    product.variants.map((variant, index) => {
      const elementKey = `product-search-result-list-${variant.sku}-${index}`;

      return (
        <ProductRow key={elementKey} hoverPointer={false}>
          <ProductCheckboxColumn>
            <ProductCheckbox
              data-testid={`radio-product-${variant.id}-${variant.sku}`}
              type="radio"
              checked={isCurrentlySelectedProduct(variant)}
              onChange={() => handleSelectedProduct(variant)}
            />
          </ProductCheckboxColumn>
          <ProductResultsColumn width="20%">
            <img
              alt={`product-${variant.sku}`}
              width="64px"
              src={variant.image ?? '/images/placeholders/product-placeholder.svg'}
            />
          </ProductResultsColumn>
          <ProductResultsColumn width="60%">{variant.title}</ProductResultsColumn>
          <ProductResultsColumn width="20%">{variant.sku}</ProductResultsColumn>
        </ProductRow>
      );
    })
  );
};

export default ProductSearchResultsList;
